import { setVehiclePart } from '../setVehiclePart'
import { setOrderForm } from '../setOrderForm'
import { setDeliveryInfo } from '../setDeliveryInfo'
import { setLoading } from '../setLoading'
import { VehiclPartDetailsApi } from '../../api'

export const fetchVehiclePart = ({ slug, locale = 'ME' }) => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true))

    const api = new VehiclPartDetailsApi()
    const { product, orderForm, deliveryInfo } = await api.getProduct({ slug, locale })

    if (product) {
      dispatch(setVehiclePart({
        ...product,
        img_putanja: typeof product.img_putanja === 'string' ? [{ img: product.img_putanja}] : product.img_putanja
      }))

      if (orderForm) {
        dispatch(setOrderForm(orderForm))
      } else {
        dispatch(setOrderForm(null))
      }

      if (deliveryInfo) {
        dispatch(setDeliveryInfo(deliveryInfo))
      } else {
        dispatch(setDeliveryInfo(null))
      }
    } else {
      dispatch(setVehiclePart(null))
      dispatch(setOrderForm(null))
      dispatch(setDeliveryInfo(null))
    }

    dispatch(setLoading(false))
  } catch (e) {
    dispatch(setVehiclePart(null))
    dispatch(setOrderForm(null))
    dispatch(setDeliveryInfo(null))
    dispatch(setLoading(false))
  }
}
